import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { EditionsProvider } from "@/context/EditionsContext";
import CartDrawer from "@/components/site/CartDrawer";
import SiteGate from "@/components/site/SiteGate";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Artists from "@/pages/Artists";
import Artist from "@/pages/Artist";
import Commission from "@/pages/Commission";
import About from "@/pages/About";
import Exhibition from "@/pages/Exhibition";
import MadeToOrder from "@/pages/MadeToOrder";
import ArtWalls from "@/pages/ArtWalls";
import { JournalIndex, JournalArticle } from "@/pages/Journal";
import Admin from "@/pages/Admin";
import ExitIntent from "@/components/site/ExitIntent";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Legal from "@/pages/Legal";
import CookieBanner from "@/components/site/CookieBanner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <EditionsProvider>
          <CartProvider>
            <SiteGate>
              <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:id" element={<Product />} />
              <Route path="/artists" element={<Artists />} />
              <Route path="/artists/:id" element={<Artist />} />
              <Route path="/cart" element={<Navigate to="/shop" replace />} />
              <Route path="/commission" element={<Commission />} />
              <Route path="/commissions" element={<Navigate to="/commission" replace />} />
              <Route path="/made-to-order" element={<MadeToOrder />} />
              <Route path="/art-walls" element={<ArtWalls />} />
              <Route path="/journal" element={<JournalIndex />} />
              <Route path="/journal/:slug" element={<JournalArticle />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/about" element={<About />} />
              <Route path="/concept" element={<Navigate to="/about" replace />} />
              <Route path="/exhibition" element={<Exhibition />} />
              <Route path="/exhibitions" element={<Navigate to="/exhibition" replace />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/legal/:page" element={<Legal />} />
            </Routes>
            <CartDrawer />
            <CookieBanner />
            <ExitIntent />
          </BrowserRouter>
            </SiteGate>
          <Toaster position="bottom-center" />
          </CartProvider>
        </EditionsProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
